import { FetchPricing } from '@atlassiansox/bxp-use-pricing';
import { PropsWithChildren, createContext } from 'react';

export interface IFetchPricing {
  getPricing: FetchPricing['getPricing'];
  getOfferingsBySKU: FetchPricing['getOfferingsBySKU'];
  ccpSearchAddons: FetchPricing['ccpSearchAddons'];
  searchAddons: FetchPricing['searchAddons'];
  getOfferingsByProductKey: FetchPricing['getOfferingsByProductKey'];
  getOfferingSkuByProductKey: FetchPricing['getOfferingSkuByProductKey'];
}
const notProvided = async () => {
  throw new Error(
    'FetchPricingProvider was not provided. Use <FetchPricingProvider />'
  );
};
export const FetchPricingContext = createContext<IFetchPricing>({
  getPricing: notProvided,
  getOfferingsBySKU: notProvided,
  ccpSearchAddons: notProvided,
  searchAddons: notProvided,
  getOfferingsByProductKey: notProvided,
  getOfferingSkuByProductKey: notProvided
});

export type FetchPricingProviderProps = {
  readonly fetchPricing: IFetchPricing;
};

export const FetchPricingProvider = ({
  fetchPricing,
  children
}: PropsWithChildren<FetchPricingProviderProps>) => {
  return (
    <FetchPricingContext.Provider value={fetchPricing}>
      {children}
    </FetchPricingContext.Provider>
  );
};
